var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLargeYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM19.9996 36.4C29.0571 36.4 36.3996 29.0575 36.3996 20C36.3996 10.9425 29.0571 3.60001 19.9996 3.60001C10.9421 3.60001 3.59961 10.9425 3.59961 20C3.59961 29.0575 10.9421 36.4 19.9996 36.4Z",
    fill: "#2B3242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4004 20L40 20C40 8.95431 31.0457 -7.8281e-07 20 -1.74846e-06L20 3.60002L20.0004 3.60002C29.0579 3.60002 36.4004 10.9425 36.4004 20Z",
    fill: "#FDDD35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeYellow);
export default __webpack_public_path__ + "static/media/large-yellow.0c01a8cf773b44af925241d1400aa4be.svg";
export { ForwardRef as ReactComponent };